export default {
  payment: {},
  getAllPayments: {},
};
